import type { ColumnsBlockProps } from "@/puck/types";

type SlotBlock = {
  type: string;
  props: Record<string, unknown> & { id: string };
};

function sectionHeadingBlock(id: string): SlotBlock {
  return {
    type: "SectionHeading",
    props: {
      id,
      eyebrow: "SEE IT RUN",
      title: "And the paperwork? <em>Filled while you watch.</em>",
      subtitle:
        "Gail completes a Certificate of Insurance and ACORD 25 end to end — pulling from your book, no template wrangling.",
      align: "left",
    },
  };
}

function topStatusPillBlock(id: string): SlotBlock {
  return {
    type: "FloatingBadge",
    props: {
      id,
      variant: "pill",
      icon: "file-lines",
      title: "ACORD 25 · auto-filled",
      status: "",
      angle: "-2",
      layout: "overlapping",
      placement: "top",
      align: "left",
      overlapMargin: 30,
    },
  };
}

function phoneVideoBlock(id: string): SlotBlock {
  return {
    type: "PhoneVideo",
    props: {
      id,
      mediaId: "cj25mopmgf",
      autoplay: false,
      label: "Gail filling a COI / ACORD form",
    },
  };
}

function bottomCoiBadgeBlock(id: string): SlotBlock {
  return {
    type: "FloatingBadge",
    props: {
      id,
      variant: "badge",
      icon: "file-circle-check",
      title: "Certificate of Insurance",
      status: "✓ Issued · 138 KB",
      angle: "2",
      layout: "overlapping",
      placement: "bottom",
      align: "right",
      overlapMargin: 56,
    },
  };
}

/** Composed "Filled while you watch" section matching the GAIL-231 design. */
export function buildFilledWhileYouWatchSectionProps(
  id = "filled-while-you-watch-section",
): ColumnsBlockProps & { id: string } {
  return {
    id,
    columnCount: 2,
    showBorder: "none",
    columnVerticalAlign: "center",
    columnBackground: "softBlue",
    columnRadius: "2xl",
    column1: [sectionHeadingBlock("filled-while-you-watch-heading")] as ColumnsBlockProps["column1"],
    column2: [
      topStatusPillBlock("filled-while-you-watch-pill"),
      phoneVideoBlock("filled-while-you-watch-video"),
      bottomCoiBadgeBlock("filled-while-you-watch-badge"),
    ] as ColumnsBlockProps["column2"],
    column3: [],
    column4: [],
    column5: [],
    column6: [],
  };
}
